export default "__VITE_ASSET__BtuSYhd5__"